import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useManageRole, usePageName } from "../Hooks";

const PermissionRoute = ({ children }) => {
  const { pageName, pathname } = usePageName();

  const {
    isDashboard,
    isSport,
    isTournament,
    isMatch,
    isMarket,
    isFancy,
    isLine,
    isBookmaker,
    isImport,
    isOpenGame,
    isUser,
    isRole,
    isGameSetting,
    isUserSetting,
    isWhiteLabelSetting,
    isLiveTv,
    isCommentary,
    isIndependent,
  } = useManageRole();

  // Map page names to their respective permissions
  const permissionMapping = {
    "image-upload": isDashboard,
    "payment-gateway": isDashboard,
    sport: isSport,
    tournaments: isTournament,
    matches: isMatch,
    market: isMarket,
    fancy: isFancy,
    line: isLine,
    bookmaker: isBookmaker,
    importradhefancy: isFancy,
    importindiafancy: isFancy,
    openmarket: isOpenGame,
    settledmarket: isOpenGame,
    cancelmarket: isOpenGame,
    casinomarket: isOpenGame,
    manageusers: isUser,
    moduleaccess: isRole,
    roles: isRole,
    gamesetting: isGameSetting,
    usersetting: isUserSetting,
    whitelabelsetting: isWhiteLabelSetting,
    apisettings: isWhiteLabelSetting,
    import: isImport,
    importdream: isImport,
    reactions: isIndependent,
    reopencancellist: isIndependent,
    matchresult: isIndependent,
    livetv: isLiveTv,
    chipssettings: isIndependent,
    welcomemsg: isIndependent,
    rulessettings: isIndependent,
  };

  if (
    pathname !== "/" &&
    (permissionMapping[pageName] === false || !permissionMapping[pageName])
  ) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PermissionRoute;
